export default __webpack_public_path__ + "static/media/bg-masthead-3-320w.4fe4d2d9.jpg";